// A shopper's choice counts from the moment they click the banner: Secure Privacy
// fires sp_*_banner_click at the top of saveAllConsents, before it relays anything
// to Shopify, and only persists sp_dynamic.saved further down. Keying off the saved
// flag alone would swallow the relay that carries the shopper's actual answer.
let spChoiceMade = false

function hasShopperChoice() {
    if (spChoiceMade) {
        return true
    }
    try {
        return JSON.parse(localStorage.getItem('sp_dynamic'))?.saved === true
    } catch (e) {
        return false
    }
}

function markShopperChoice() {
    spChoiceMade = true
}

function isConsentDenial(consent) {
    return ['analytics', 'marketing', 'sale_of_data'].some(key => consent?.[key] === false)
}

// Shopify already persists the shopper's answer, so re-sending the same values tells it
// nothing new - but a repeated denial still costs us the session, because Shopify drops
// _shopify_s every time it is told tracking is denied. Comparing against what Shopify
// currently holds lets a returning shopper's stored choice stand untouched while a real
// change, or a first report after Shopify's own record lapsed, still gets through.
function isRedundantConsent(consent) {
    try {
        const current = window.Shopify.customerPrivacy.currentVisitorConsent()
        const keys = ['analytics', 'marketing', 'preferences', 'sale_of_data']
            .filter(key => typeof consent?.[key] === 'boolean')

        return keys.length > 0 && keys.every(key => current?.[key] === (consent[key] ? 'yes' : 'no'))
    } catch (e) {
        return false
    }
}

// Shopify deletes _shopify_s the moment it is told tracking is denied, then mints a
// fresh one on the next page load - which Shopify's new session measurement counts as
// a brand-new session, inflating sessions and depressing conversion rate. Until the
// shopper actually answers the banner we have no choice to report, so say nothing and
// let Shopify's own regional default stand. This guards every caller, including Secure
// Privacy's own relay inside secure-privacy-v2.js, which we do not control.
function guardTrackingConsent() {
    const customerPrivacy = window.Shopify.customerPrivacy
    if (customerPrivacy.zumbaConsentGuarded) {
        return
    }

    const setTrackingConsent = customerPrivacy.setTrackingConsent.bind(customerPrivacy)
    customerPrivacy.setTrackingConsent = function (consent, callback) {
        if ((!hasShopperChoice() && isConsentDenial(consent)) || isRedundantConsent(consent)) {
            return typeof callback === 'function' ? callback() : undefined
        }
        return setTrackingConsent(consent, callback)
    }

    customerPrivacy.zumbaConsentGuarded = true
}

function triggerConsentUpdateEvents() {

    const defaultConsents = sp.subConsents
    const spStorageKey = 'sp_consent'
    const storedConsent = JSON.parse(localStorage.getItem(spStorageKey))
    const consentCatMap = {
        Advertising: ['ad_storage', 'ad_user_data', 'ad_personalization'],
        Analytics: ['analytics_storage']
    }

    const shTrackingConsents = {
        "analytics":    false,
        "marketing":    false
    }

    defaultConsents?.forEach(con => {
        const consentCats = consentCatMap[con.ComplianceType] || []
        consentCats?.forEach(cat => {
            con.consentGiven && window.Shopify.analytics.publish('sp_category_consent_updated', {
                categoryName: cat,
                consentGiven: con.ConsentGiven
            })

            if (con.ComplianceType === 'Advertising') {
                shTrackingConsents.marketing = con.ConsentGiven
            }

            if (con.ComplianceType === 'Analytics') {
                shTrackingConsents.analytics = con.ConsentGiven
            }
        })
        con.PluginPreferences?.forEach(plugin => {
            let consentGranted = !plugin.IsBlockEnabled
            const storedConsentGroup = storedConsent.find(g => g.ComplianceType === con.ComplianceType)
            const storedPluginConsent = storedConsentGroup?.PluginPreferences?.find(p => p.ComplianceType === plugin.ComplianceType)
            if (storedPluginConsent !== undefined) {
                consentGranted = !storedPluginConsent.IsBlockEnabled
            }
            consentGranted && window.Shopify.analytics.publish('sp_consent_updated', {
                serviceName: plugin.ComplianceType,
                consentGiven: consentGranted
            })

            /*if (plugin.ComplianceType === 'Adroll' && consentGranted) {
                injectAdRollScript()
            }*/
        })
    })

    // This is for the shopify App Pixels (1st party / installed)
    window.Shopify.customerPrivacy.setTrackingConsent(
        shTrackingConsents,
        () => console.log("Consent captured")
    )
}

function injectAdRollScript() {
    const arScript = document.createElement('script')
    arScript.src = "https://assets1.adroll.com/shopify/latest/j/shopify_rolling_bootstrap_v2.js?adroll_adv_id=MOFSJUGYS5BMNBSDOYWRNN&adroll_pix_id=YYHGANFVCZFLXCIWSIUGQP&shop=zumbaapparel.myshopify.com"
    arScript.async = true
    document.head.appendChild(arScript)
}

function spInitialized(e) {
    // Only replay consent on load for a shopper who has already answered the banner.
    // Replaying it unconditionally is what re-sent "denied" on every page view.
    if (hasShopperChoice()) {
        setTimeout(triggerConsentUpdateEvents, 500)
    }

    // Added by Zumba Tech
    window.spOpenPrivacySettings = function() {
        sp.showPrivacyBanner()
    }
}

if (Swivel.featureEnabled('SECURE_PRIVACY')) {
    window.Shopify.loadFeatures(
        [
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
        ],
        error => {
            if (error) {
                console.error('Error loading consent api', error)
                return
            }

            // Must be in place before Secure Privacy loads, so its own relay is covered.
            guardTrackingConsent()

            // 1. load secure privacy script
            const spScript = document.createElement('script')
            spScript.src = "https://app.secureprivacy.ai/script/682cd8faa32b1bf9b591e863.js"
            spScript.async = true
            document.head.appendChild(spScript)

            // 2. setup listeners
            window.addEventListener('sp_cookie_banner_click', markShopperChoice)
            window.addEventListener('sp_privacy_banner_click', markShopperChoice)
            window.addEventListener('sp_init', spInitialized)
            window.addEventListener('sp_cookie_banner_save', triggerConsentUpdateEvents)
            window.addEventListener('sp_privacy_banner_save', triggerConsentUpdateEvents)
        },
    )
}
